<template>
<div class="container-fluid">
	<img v-if="!data_loaded" class="center-me" src="/images/loading-color.svg">

	<template v-else>
		<div class="row">
		    <div class="col">
				<h1 data-test="pageTitle">{{ org.name }}</h1>
			</div>
		</div>

		<div class="row org">
			<div class="col-lg-8 col-12">
				<div class="card">
					<div class="card-header">Clients</div>

					<div v-for="client in org.clients" class="px-35 py-4 border-bottom">
						<div class="d-flex">
							<div class="rounded-circle avatar-md circle-cropped mr-2 bg-gray-100 text-center">
								<img v-if="client.logo_url" class="img-fluid" :src="client.logo_url">
								<i v-else class="fal fa-hospital text-gray-500"></i>
							</div>

							<div class="flex-grow-1 pt-1">
								<div>
									<span class="text-primary cursor-pointer" @click="toggleClient(client.id)" data-test="toggleClient">{{ client.name }}</span>
									<i v-if="user.client_id === client.id" v-tooltip.bottom="'Active client'" class="fas fa-check-circle text-primary ml-2"></i></div>
								<span v-for="service_line in client.service_lines" class="badge bg-orange-100 text-orange-700 mr-1">{{ service_line.label }}</span>
							</div>
						</div>

						<div class="d-flex align-items-baseline text-center mt-3 mx-3 leading-none">
							<div class="d-flex" :class="{ 'border-highlight pb-4' : clientsToShow.includes(client.id) }">
								<div class="pr-3 border-right">
									<span class="text-gray-500 text-sm">Referrals</span>
									<div class="text-2xl pt-2">
										{{ client.referrals_count }}
									</div>
								</div>
								<div class="px-3 border-right">
									<span class="text-gray-500 text-sm">Checkins</span>
									<div class="text-2xl pt-2">
										{{ client.checkins_count }}
									</div>
								</div>
								<div class="px-3 border-right">
									<span class="text-gray-500 text-sm">Activities</span>
									<div class="text-2xl pt-2">
										{{ parseInt(client.campaigns_count) + parseInt(client.routes_count) }}
									</div>
								</div>								
								<div class="px-3">
									<span class="text-gray-500 text-sm">Goals</span>
									<div class="text-2xl pt-2">
										{{ client.goals_count }}
									</div>
								</div>
<!-- 								<div class="px-3">
									<span class="text-gray-500 text-sm">Routes</span>
									<div class="text-2xl pt-2">
										{{ client.routes_count }}
									</div>
								</div> -->
							</div>
							
							<div v-if="$mq != 'xs'" class="flex-fill">
								<span class="text-gray-500 text-sm">Users</span>
								<div class="d-flex justify-content-center" @click="toggleUsers(client.id)">
									<div class="text-2xl d-flex">										
										<div class="d-flex ml-2" :class="usersExpanded.includes(client.id) ? 'flex-column' : 'avatars-overlapped'">

											<div v-for="user in client.users.slice(0, usersExpanded.includes(client.id) ? 100 : numUsersShown)" class="d-flex align-items-center mb-2">
												<div class="rounded-circle avatar-md circle-cropped" v-tooltip.bottom="usersExpanded.includes(client.id) ? null : user.display_name">
													<img class="img-fluid" :src="user.photo_url">
												</div>
												<div v-if="usersExpanded.includes(client.id)" class="text-base ml-1">{{ user.display_name }}</div>
											</div>

											<div v-if="client.users.length > numUsersShown && !usersExpanded.includes(client.id)" class="rounded-circle avatar-md circle-cropped bg-gray-500 text-white text-center text-lg font-weight-bold cursor-pointer">
												<div style="margin-left:-3px;">
													+{{ client.users.length - numUsersShown }}													
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
	    				</div>

		    			<org-item-client-snapshot v-if="clientsToShow.includes(client.id)" :client_id="client.id" />

					</div>
				</div>
			</div>

			<div class="col-lg-4 col-12">
				<div class="card">
					<div class="card-header d-flex justify-content-between align-items-center">
						Members
						<span
						    v-if="perms.can_assign_user_org"
						    @click="showUserMgmtForm()"
						    v-tooltip.bottom="'Manage members'"
						    class="btn btn-sm btn-ghost-primary text-gray-500 cursor-pointer leading-none"
						    data-test="editMembersButton">
						    <i class="far fa-cog text-base" />
						</span>						
					</div>
					<ul class="list-group list-group-flush" data-test="orgUsersList">
						<li v-for="user in org.users" class="list-group-item d-flex  drop-down-hover">
							<div class="rounded-circle avatar-md circle-cropped mr-2">
								<img class="img-fluid" :src="user.photo_url">
							</div>
							<div class="flex-grow-1">
								<router-link :to="{ name: 'users.show', params: { id: user.id } }" class="font-weight-bold">{{ user.display_name }} <i v-if="user.roles.some(role => role.name == 'org admin')" class="fas fa-star text-2xs align-text-top text-blue-500"></i></router-link><br>
								<span v-for="role in user.roles" class="badge bg-blue-100 text-blue-700 mr-1">{{ role.name }}</span>
							</div>

		                    <div class="drop-down dropleft">
		                        <a href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
		                            <i class="far fa-ellipsis-h text-xl"></i>
		                        </a>
		                        <div class="dropdown-menu py-0">
		                            <router-link v-if="user.can.update" :to="{ name: 'users.settings', params: { id: user.id } }" class="dropdown-item">Edit User</router-link>
		                        </div>
		                    </div>
						</li>
					</ul>

					<div v-if="userMgmtFormVisible && clientUsers.length" class="px-35 py-25" data-test="usersList">
						<div class="text-gray-500 font-weight-bold text-sm text-uppercase">Select users</div>
						<div v-for="user in clientUsers" class="d-flex align-items-center my-25">
							<input class="mr-2" type="checkbox" v-model="users_selected" :value="user.id" :disabled="user.id == $store.state.user.id">
							<div class="rounded-circle avatar-xs circle-cropped mr-2">
								<img class="img-fluid" :src="user.photo_url">
							</div>
							<div>
								{{ user.display_name }}
								<span v-for="role in user.roles" class="badge bg-blue-100 text-blue-700 mr-1">{{ role.name }}</span>
							</div>
							<i v-if="users_original.includes(user.id) && !users_selected.includes(user.id)" class="fal fa-exclamation-triangle text-red-500" v-tooltip:bottom="'Will be removed!'"></i>
						</div>
						<div class="text-right mt-35 mb-2">
							<span class="btn btn-sm btn-ghost-secondary" @click="hideUserMgmtForm()">Cancel</span>
							<span class="btn btn-sm btn-primary" @click="saveOrgUsers()" data-test="saveMembersButton">Save Members</span>
						</div>
					</div>
					
					<div class="card-footer">
						Members can see this organization and the clients of which they are members. Admins can manage the user list and have access to all clients.
					</div>
				</div>
			</div>			
		</div>
	</template>

</div>
</template>

<script>
	import { mapState } from 'vuex';
	import BreadcrumbsManager from '../../helpers/BreadcrumbManager';
	import OrgItemClientSnapshot from '../../components/OrgItemClientSnapshot';

    export default {
    	components: {
    		OrgItemClientSnapshot,
    	},

    	mixins: [BreadcrumbsManager],

        data() {
            return {
                data_loaded: false,
                org: {},

                clientsToShow: [],
                numUsersShown: 3,
                usersExpanded: [],

                userMgmtFormVisible: false,
                users: [],
                users_original: [],
                users_selected: [],
            }
        },

        created() {
        },

		activated() {
			this.fetchOrg();
			this.setBreadcrumbs([
		        { text: 'Home', to: { name: 'home' } },
		        { text: 'Organizations', to: { name: 'orgs.index' } },
		        { text: '[Organization Name]' },
		    ]);  
		},

        methods: {
			fetchOrg() {
				axios.get('/api/admin/orgs/' + this.$route.params.id).then(({data}) => {
					this.org = data;
					this.data_loaded = true;
					this.replaceBreadcrumb({
						find: '[Organization Name]',
						replace: { text: this.org.name }
					});	
				});
			},

			fetchUsers() {
				axios.get('/api/admin/users').then(({data}) => {
					this.users = data;
				});
			},

			hideUserMgmtForm() {
				this.userMgmtFormVisible = false;
			},

			saveOrgUsers() {
				axios.put('/api/admin/orgs/' + this.$route.params.id + '/users', { users: this.users_selected}).then(({data}) => {
					//this.org.users = [];
					this.org.users = data;
					this.hideUserMgmtForm();
				});
			},

			showUserMgmtForm() {
				this.userMgmtFormVisible = true;
				this.fetchUsers();
				this.users_original = this.org.users.map(user => user.id);
                this.users_selected = this.users_original;				
			},

			toggleClient(id) {
				if (this.clientsToShow.includes(id)) {
					this.clientsToShow.splice(this.clientsToShow.findIndex(clientId => { return clientId == id}), 1);
				}
				else {
					this.clientsToShow.push(id);
				}
			},

			toggleUsers(id) {
				if (this.usersExpanded.includes(id)) {
					this.usersExpanded.splice(this.usersExpanded.findIndex(clientId => { return clientId == id}), 1);
				}
				else {
					this.usersExpanded.push(id);
				}
			},
        },

        computed: {
        	...mapState(['perms', 'user']),

			clientUsers() {
				return this.users.filter(user => { 
					return user.client_list_all.some(client => {
						return this.org.clients.map(clientItem => clientItem.id).includes(client.id);
					});
				});
			}        	
        },

		watch: {
			clientUsers() {
				this.users_selected = this.users_selected.filter(id => this.clientUsers.map(user => user.id).includes(id));
			}
		}        
    }	
</script>